/**
 * v3 API 统一响应解包工具
 *
 * v3 所有 API 返回 { success, data, error, timestamp } 格式。
 * 此函数解包该格式：成功返回 data，失败抛出 Error。
 *
 * @template T
 * @param {Promise<{success: boolean, data?: T, error?: {code: string, message: string}}>} promise
 * @returns {Promise<T>}
 *
 * @example
 * const data = await unwrap(apiFetchBots());
 * setBots(data.bots);
 */
export async function unwrap(promise) {
  const result = await promise;
  if (!result.success) {
    throw new Error(result.error?.message || "请求失败");
  }
  return result.data;
}
